import { render } from "./custom-btn.vue?vue&type=template&id=43182a8f&scoped=true"
import script from "./custom-btn.vue?vue&type=script&lang=js"
export * from "./custom-btn.vue?vue&type=script&lang=js"

import "./custom-btn.vue?vue&type=style&index=0&id=43182a8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43182a8f"]])

export default __exports__